









import { defineComponent } from '@nuxtjs/composition-api'
import { useProductStore } from '~/store/product'
import { useI18n } from '~/composables/i18n'
import { buildAntibodyFeatureReferenceCsvLink } from '~/common/utils/urls'
import IconFaFileCsv from '~icons/fa-solid/file-csv'

export default defineComponent({
  components: {
    IconFaFileCsv,
  },
  setup() {
    const { currentProduct } = useProductStore()
    const { t } = useI18n()
    const downloadAntibodyReferenceCsvLink = buildAntibodyFeatureReferenceCsvLink(currentProduct.data.key)
    return { t, downloadAntibodyReferenceCsvLink }
  },
})
